// ** React Imports
import React from "react";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

// #####################################################

const ParameterBlock = styled(({ $toModerate, $fullWidth, ...props }) => (
	<Block {...props} />
))`
	${({ $toModerate }) =>
		$toModerate &&
		css`
			background-color: ${({ theme: { colors } }) =>
				colors.buttonsDefaultGrey};
			padding: 0.75rem;
			border-radius: ${({ theme: { borderRadius } }) =>
				borderRadius.element};
		`}

	${({ $fullWidth }) =>
		$fullWidth &&
		css`
			width: 100%;
		`}
`;

// #####################################################

export const UserpanelRow = ({
	label,
	labelStyle,
	children,
	toModerate,
	fullWidth,
}) => {
	return (
		<ParameterBlock
			flex
			column
			$toModerate={toModerate}
			$fullWidth={fullWidth}
		>
			{label && (
				<Block style={labelStyle}>
					<Text small>{label}:</Text>
				</Block>
			)}
			<Block>{children}</Block>
		</ParameterBlock>
	);
};

// #####################################################
